$(document).ready(function () {

    $("a[href*='#']:not([href='#'])").on("click", function (event) {
        // Check if the clicked link has data-toggle="modal" or data-toggle="tab" attribute
        if ($(this).attr("data-toggle") === "modal" || $(this).attr("data-toggle") === "tab") {

            return;
        }

        // Get the href attribute value
        let target = $(this).attr("href");

        // Check if the target starts with /# or #
        let isSamePage = location.pathname === "/" || location.pathname === $(this).attr("pathname");

        if (target.startsWith('/#')) {
            target = target.substring(1); // Remove the leading slash
        }

        if (isSamePage) {
            // Prevent default behavior and handle smooth scroll for same-page links
            event.preventDefault();

            if (target !== "#") {
                if ($(window).width() <= 1080) {
                    if ($('html').hasClass('overflow-hidden')) {
                        $('.navbar-toggle').click();
                    }
                }

                $("html, body").animate({
                    scrollTop: $(target).offset().top
                }, 800);
            }
        } else {
            // Let the browser handle the navigation for different pages
            window.location.href = target;
        }
    });
});
